import { render, staticRenderFns } from "./FormatoBoletaMensual.vue?vue&type=template&id=459421f9&scoped=true&"
import script from "./FormatoBoletaMensual.vue?vue&type=script&lang=js&"
export * from "./FormatoBoletaMensual.vue?vue&type=script&lang=js&"
import style0 from "./FormatoBoletaMensual.vue?vue&type=style&index=0&id=459421f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459421f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDataTable,VRow,VSpacer})
